import MatchedMap from 'utilities/src/matchedMap';

import { SiteSizeEnum } from './_size';

/**
 * Site Theme / Button Common Classes
 */

const buttonSiteClasses = '[&_svg]:fill-current outline-none';

/**
 * Site Theme / Button Common Size Classes
 */

const buttonSiteSizeClassesMap = new MatchedMap([
  [SiteSizeEnum.XLarge, 'py-3 site-display-xs font-medium'],
  [SiteSizeEnum.Large, 'py-3 site-paragraph-xl font-medium'],
  [SiteSizeEnum.Medium, 'py-2.5 site-paragraph-m font-medium'],
  [SiteSizeEnum.Small, 'py-2 site-paragraph-s font-medium'],
]);

export default { buttonSiteClasses, buttonSiteSizeClassesMap };
